<div class="h-100 login-container d-flex align-items-center justify-content-center">
  <div>
    <img [src]="appService.systemTheme == 'dark' ? './assets/images/presonus_logo.png' : './assets/images/presonus_logo_black.png'" />
  </div>
</div>
